import { PurchaseOffering } from '@wix/premium-purchase-platform/@sdk';
export const cycleSlug = cycle => {
  var _cycle$cycleDuration, _cycle$cycleDuration2;
  const count = ((_cycle$cycleDuration = cycle.cycleDuration) == null ? void 0 : _cycle$cycleDuration.count) ?? 1;
  const unit = (_cycle$cycleDuration2 = cycle.cycleDuration) == null ? void 0 : _cycle$cycleDuration2.unit;
  if (unit === PurchaseOffering.DurationUnit.MONTH && count === 1) {
    return 'monthly';
  }
  if (unit === PurchaseOffering.DurationUnit.YEAR && count === 1) {
    return 'yearly';
  }
  return `${count}year`;
};

/** `isSale` selects the mid-sale title, which interpolates savings rather than prices. */
export const getHigherCycleCopyKeys = function (targetCycle, isSale) {
  if (isSale === void 0) {
    isSale = false;
  }
  const slug = cycleSlug(targetCycle);
  return {
    titleKey: isSale ? `checkout.summary.${slug}_upsell.sale.benefits.title` : `checkout.summary.${slug}_upsell.benefits.title`,
    ctaKey: `checkout.summary.${slug}_upsell.switch_cycle.cta`
  };
};
export const getLowerCycleCtaKey = (currentCycle, lowerCycle) => `checkout.summary.${cycleSlug(currentCycle)}_upsell.switch_${cycleSlug(lowerCycle)}_cycle.cta`;
//# sourceMappingURL=upsellCopyKeys.js.map